import React from "react"
import { bem } from "../../helpers"
import PropTypes from "prop-types"
import BaseField from "../Field/Base";

export class TextArea extends BaseField {
  inputType="text-area"
  renderInput = () => {
    const {
      id,
      label,
      placeholder,
      disabled,
      rows,
      className,
      inputProps,
      labelProps,
    } = this.props
  
    return (
      <textarea
        id={id}
        name={this.name()}
        disabled={disabled}
        placeholder={placeholder}
        value={this.value()}
        onChange={this.onChange}
        rows={rows}
        {...inputProps}
        className={bem("text-area", "input", [])} 
      />
    )
  }

}

TextArea.propTypes = {
  ...BaseField.propTypes,
  label: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rows: PropTypes.number
}

TextArea.defaultProps = BaseField.defaultProps

export default TextArea
